<div [formGroup]="form">
  <mdb-form-control>
    <input
      mdbInput
      [value]="displayText"
      (input)="onNativeInput($event)"
      (focus)="onFocus()"
      (blur)="onInputBlur($event)"
      [mdbAutocomplete]="autocomplete"
      type="text"
      (keydown)="onKeydown($event)"
      id="autocomplete"
      class="form-control"
      [placeholder]="placeholder"
      required="{{ required }}"
      [class.is-invalid]="(control?.dirty || submitted) && required && control?.invalid"
    />
  </mdb-form-control>
  <mdb-autocomplete #autocomplete="mdbAutocomplete" [displayValue]="displayValue" (selected)="handleChange($event)">
    @for (option of results | async; track option) {
      <mdb-option [value]="option" (mousedown)="$event.preventDefault()">
        {{ getOption(option) }}
      </mdb-option>
    }
    @if (notFound) {
      <div class="autocomplete-no-results">No results found</div>
    }
  </mdb-autocomplete>
</div>
